module.exports = __webpack_public_path__ + "img/icon-sport-active.623b572.webp";